import React from "react";
import { Link } from "react-router-dom";
import SignInPresenter from "./SignInPresenter";
import { signInUseCase } from "../../usecases/user";
import { Button } from "../../nq-component";
import BasePage from "../../base/BasePage";
import withRouter from "../../utils/withRouter";
import InputFactory from "../../components/InputFactory";
import { findObjectUseCase } from "../../usecases/object";
import { Toaster } from "react-hot-toast";

class SignInPage extends BasePage {
  constructor() {
    super();
    this.presenter = new SignInPresenter(
      this,
      signInUseCase(),
      findObjectUseCase(),
    );
    this.state = { loading: false };
  }

  formSubmit(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  getMasterKey() {
    return this.props.params && this.props.params.masterKey;
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  render() {
    return (
      <div className="vh-100 bg-light">
        <Toaster />
        <div className="d-flex h-100">
          <div className="m-auto container p-3 p-lg-5">
            <div className="bg-white rounded p-3 p-lg-5">
              <div className="row">
                <div className="col-md-6 border-end border-1">
                  <div className="h-100 d-flex align-items-center">
                    <div className="text-center p-3 w-100">
                      <img
                        className="img-fluid login-img mb-3 w-50"
                        alt="company logo"
                        src="/f2.png"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 p-3 px-lg-5 py-lg-4">
                  <form onSubmit={this.formSubmit.bind(this)}>
                    <div className="row g-3">
                      <div className="col-md-12">
                        <label className="form-label fs-sm">Username</label>
                        <InputFactory
                          required
                          type="Username"
                          autoComplete="nope"
                          className="form-control"
                          placeholder="Enter your username"
                          field="username"
                          onChange={this.onChange.bind(this)}
                        />
                      </div>
                      <div className="col-md-12">
                        <label className="form-label fs-sm">Password</label>
                        <InputFactory
                          type="Password"
                          required
                          className="form-control"
                          placeholder="Enter your password"
                          field="password"
                          onChange={this.onChange.bind(this)}
                        />
                      </div>
                      <div className="text-center">
                        <Button
                          progress={this.state.loading}
                          disabled={this.state.loading}
                          style={{ backgroundColor: "#1f1c58" }}
                          type="submit"
                          className="btn btn-primary w-50"
                        >
                          {this.state.loading ? "Please wait..." : "LOGIN"}
                        </Button>
                      </div>
                      <div className="text-center">
                        <span className="fs-sm">
                          Don't have an account?
                          <Link to="/signup" className="ms-1">
                            <span className="text-decoration-underline">
                              Sign up
                            </span>
                          </Link>
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignInPage);
